import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import {
  Header,
  HeaderLeftItems,
  HeaderH4,
  HeaderH5,
  CenterHeader
} from './HeaderStyle'
import PropTypes from 'prop-types'
class HeaderComponent extends Component {
      constructor () {
        super()
        this.state = {
          openInfo: false,
          openGlossary: false,
          openHelp: false
        }
      }
      static propTypes = {
        params: PropTypes.object
      }

      move = (link) => {
        browserHistory.push(link)
      }

      handleChangeModal (name) {
        let change = { ...this.state }
        change[name] = !change[name]
        this.setState(
          change
        )
      }
      render () {
        const { params } = this.props
        const names = {
          'highrisk': 'EMPLOYMENT INTERVENTION',
          'communityworkers': 'COMMUNITY WORKERS INTERVENTION',
          'cpos': 'COMMUNITY POLICING INTERVENTION'
        }
        return (
          <Header>
            <HeaderLeftItems>
              <HeaderH4 onClick={() => this.move('/')}>
                PROTON
              </HeaderH4>
              <HeaderH5 onClick={() => this.move('/')}>
                TERRORISTS NETWORKS
              </HeaderH5>
            </HeaderLeftItems>
            {params.type === 'experiment' &&
            <CenterHeader>{names[params.highRiskEmployed]}</CenterHeader>}
          </Header>
        )
      }
}

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/HeaderComponent/HeaderComponent.js